/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["e mesnatës", "e mesditës", "e mëngjesit", "e paradites", "e pasdites", "e mbrëmjes", "e natës"], u, u], [["mesnatë", "mesditë", "mëngjes", "paradite", "pasdite", "mbrëmje", "natë"], u, u], ["00:00", "12:00", ["04:00", "09:00"], ["09:00", "12:00"], ["12:00", "18:00"], ["18:00", "24:00"], ["00:00", "04:00"]]];
